import { action, observable } from 'mobx';

export type TagItem = {
  id: string;

  // label per locale
  label: {
    zh_CN: string;
    en_US: string;
  };

  /** tag's route path */
  path: string;

  /** can be closed ? */
  closable: boolean;
};

export default class TagsStore {
  @observable public tags: TagItem[] = [];

  @observable public activeTagId: string = '';

  @action.bound public setActiveTag(activeTagId) {
    this.activeTagId = activeTagId;
  }

  @action.bound public addTag(item: TagItem) {
    if (!this.tags.find((tag) => tag.id === item.id)) {
      this.tags.push(item);
    }
  }

  @action.bound public removeTag(targetKey: string) {
    // dashboard cloud't be closed
    if (targetKey === this.tags[0].id) {
      return;
    }

    let lastIndex = 0;

    this.tags.forEach((tag, i) => {
      if (tag.id === targetKey) {
        this.tags.splice(i, 1);
        lastIndex = i - 1;
      }
    });
    const tagList = this.tags.filter((tag) => tag.id !== targetKey);
    if (tagList.length && this.activeTagId === targetKey) {
      if (lastIndex >= 0) {
        this.activeTagId = tagList[lastIndex].id;
      } else {
        this.activeTagId = tagList[0].id;
      }
    }
  }

  @action.bound public removeAllTag() {
    this.activeTagId = this.tags[0].id;
    this.tags = [this.tags[0]];
  }

  @action.bound public removeOtherTag() {
    const activeTag = this.tags.find((tag) => tag.id === this.activeTagId);
    const activeIsDashboard = activeTag!.id === this.tags[0].id;

    this.tags = activeIsDashboard ? [this.tags[0]] : [this.tags[0], activeTag!];
  }
}
